import Markdown from "react-markdown";

type Props = {
  title?: string;
  content?: string;
};

export const Tab = ({ title, content }: Props) => {
  return (
    <section>
      <div className="container mx-auto">
        <div className="flex justify-center">
          <div className="w-full">
            <div className="mb-8">
              <div className="bg-primary-light text-white w-fit rounded-tr-3xl rounded-tl-3xl px-8 py-2">
                <Markdown
                  components={{
                    p: ({ children, ...rest }) => (
                      <p className="text-2xl" {...rest}>
                        {children}
                      </p>
                    ),
                  }}
                >
                  {title}
                </Markdown>
              </div>
              <div className="bg-white border-primary-light border-1 rounded-tr-xl rounded-br-xl rounded-bl-xl px-6 py-5">
                <Markdown
                  components={{
                    p: ({ children, ...rest }) => (
                      <p className="" {...rest}>
                        {children}
                      </p>
                    ),
                  }}
                >
                  {content}
                </Markdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
